import {BaseService} from "./base.service";

class TicketInvoiceService extends BaseService {
    constructor() {
        super('api/ticket-invoice');
    }
}

export const ticketInvoiceService = new TicketInvoiceService();
